import { axios } from '@/utils/request'

/**
 * 查询问诊订单管理
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function inquiryorderPage (parameter) {
  return axios({
    url: '/baCheckout/checkoutList',
    method: 'get',
    params: parameter
  })
}

/**
 * 问诊订单管理列表
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function inquiryorderList (parameter) {
  return axios({
    url: '/inquiryorder/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 添加问诊订单管理
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function inquiryorderAdd (parameter) {
  return axios({
    url: '/inquiryorder/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑问诊订单管理
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function inquiryorderEdit (parameter) {
  return axios({
    url: '/inquiryorder/edit',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除问诊订单管理
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function inquiryorderDelete (parameter) {
  return axios({
    url: '/inquiryorder/delete',
    method: 'post',
    data: parameter
  })
}

/**
 * 导出问诊订单管理
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function inquiryorderExport (parameter) {
  return axios({
    url: '/inquiryorder/export',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}



/**
 * 获取问诊订单详情
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function recipeDetial (parameter) {
  return axios({
    url: '/baCheckout/checkoutDetailList',
    method: 'get',
    params: parameter,
  })
}
